import * as clsApi from "./classroomApi";

interface Reward {
	tag?: string; // If reward is for a signature
	website?: string; // If reward is for a website
}

export type ClassroomPolicy = {
	allowed: FilteringRule[];
	blocked: FilteringRule[];
	bypass_active_until: number; // Epoch time
	chat_blocked: boolean;
	exceptions: string[];
	internet_blocked: boolean;
	internet_blocked_lifetime: number;
	internet_blocked_override: number;
	locked_users: string[]; // Paused students
	name: string;
	reward: Reward[];
	reward_active_until: number; // Epoch time
	skipValidations: boolean;
};

export type UpdateClassroomPolicyRequest = {
	classId: string;
	policy_id: string;
	policy: ClassroomPolicy;
};

export type GetClassroomPolicyResponse = {
	policy: ClassroomPolicy;
	appControls?: NativeAppControlRule[]; // Will be null if feature flag is off
};

export type FilteringRule = {
	id: string;
	tag?: string; // If rule is filtering a signature
	website?: string; // If rule is filtering a website
	enabled: boolean;
	type: "allowed" | "blocked";
	permanent: boolean;
	validated: boolean;
	user?: string; // Student's username if applied to only one student
};

export type NativeAppControlRule = {
	id: string;
	appControlId: string;
	name: string;
	isClassroomRule: boolean;
	action: "block" | "allow";
	studentStableIdV1?: string; // Student's ID if applied to only one student
};

export async function getClassroomPolicy(
	classroomName: string,
	classroomStableIdV1: string,
	includeAppControls: boolean
): Promise<GetClassroomPolicyResponse> {
	const res: GetClassroomPolicyResponse = await clsApi.Get(
		`classrooms/policies?classroomName=${encodeURIComponent(
			classroomName
		)}&classroomStableIdV1=${classroomStableIdV1}&ffAppControls=${includeAppControls.toString()}`
	);
	return res;
}

export async function setClassroomPolicy(body: UpdateClassroomPolicyRequest): Promise<void> {
	return await clsApi.Post("classrooms/policies", body);
}
